var map = {
	"./accountmanagement-default.svg": "5a09",
	"./accountmanagement-selected.svg": "d1f2",
	"./arrowDown.svg": "32d7",
	"./arrowUp.svg": "b362",
	"./card-liulan.svg": "4ab9",
	"./changepassword-default.svg": "a74a",
	"./changepassword-selected.svg": "cc67",
	"./collection_default.svg": "3601",
	"./collection_delete.svg": "db98",
	"./collection_selected.svg": "7ce0",
	"./commitment.svg": "b9c9",
	"./custom-diamond.svg": "0493",
	"./custom-gold.svg": "9507",
	"./custom-watch.svg": "057d",
	"./dianhua-2.svg": "8f6e",
	"./dizhi.svg": "85c2",
	"./exit_default.svg": "4520",
	"./exit_selected.svg": "1219",
	"./footprint_default.svg": "9066",
	"./footprint_selected.svg": "f8c3",
	"./gold-setting-custom.svg": "e31a",
	"./gold-setting-spot.svg": "8323",
	"./gouwuche.svg": "6562",
	"./guide.svg": "72d1",
	"./hollow-love.svg": "1855",
	"./homeIcon.svg": "a887",
	"./logmanagement-default.svg": "c11d",
	"./logmanagement-selected.svg": "fba2",
	"./myOrder.svg": "00c9",
	"./organization-default.svg": "6d9b",
	"./organization-selected.svg": "5c0f",
	"./pre-sale-label.svg": "d168",
	"./pre-sale-shopCart.svg": "71be",
	"./pre-sale-tab.svg": "78da",
	"./question-mark.svg": "498f",
	"./solid-love.svg": "888d",
	"./sousuo.svg": "21a8",
	"./spot-diamond.svg": "0e8a",
	"./spot-gold.svg": "f08b",
	"./spot-watch.svg": "a95d",
	"./wode.svg": "5788",
	"./youxiang.svg": "e581"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";